<template>
	<div class="shop_detail">
		<div class="base_info d-flex flex-column j-sb a-center">
			<header class="w-100 d-flex j-sb a-center" style="margin-bottom: 1.6rem;">
				<div class="d-flex j-center a-center">
					<img src="../../assets/distributors/biaoqian@2x.png" style="width: 0.94rem; height: 1.13rem;margin-right: 0.28rem;">
					<span style="font-size: 1rem;font-weight: 700;">门店基本信息</span>
				</div>
				<div class="d-flex j-center a-center">
					<router-link style="color: #BBBBBB;font-size: 0.75rem;" :to="{name:'more_detail',params:{id:agent_id}}" v-slot="{ href, route, navigate, isActive, isExactActive }"
					 custom>
						<a :href="href" class="d-flex j-center a-center" style="text-decoration: none;">
							<span>查看详细信息</span>
							<img src="@/assets/Home/kanquanbu@2x.png" style="width: 0.58rem;height: 0.58rem;">
						</a>
					</router-link>
				</div>
			</header>
			<content class="flex-1 w-100 d-flex j-start a-start">
				<div class="icon" style="width: 5.63rem;height: 5.63rem; border-radius: 50%; border: 4px solid #FFFFFF;
					box-shadow: 0px 10px 9px 0px rgba(30, 105, 255, 0.3), 0px 0px 20px 0px rgba(0, 0, 0, 0.58) inset;margin-right: 1rem;">
				</div>
				<div class="h-100 d-flex flex-column j-sb a-start" style="font-size: 0.75rem;color: #666666;width: 66%;">
					<div class="d-flex j-start a-center">
						<span style="font-size: 0.94rem;font-weight: 700;color: #000000;">{{shopDetail.agent_name}}</span>
						<div v-if="shopDetail.is_confirm == 0" style="font-size: 0.56rem;color: #FFFFFF;width: 2.9rem;height: 0.94rem;line-height: 0.94rem;text-align: center; background: #FFB400;border-radius: 9px 7px 7px 0;margin-left: 0.38rem;">已关闭</div>
						<div v-else style="font-size: 0.56rem;color: #FFFFFF;width: 2.9rem;height: 0.94rem;line-height: 0.94rem;text-align: center; background: greenyellow;border-radius: 9px 7px 7px 0;margin-left: 0.38rem;">运营中</div>
					</div>
					<span>{{shopDetail.province + '省' + shopDetail.city + '市' + shopDetail.district + shopDetail.stores_address}}</span>
					<span>{{shopDetail.stores_tel}}</span>
					<span>{{shopDetail.seller_name}}</span>
					<div class="w-100 d-flex j-sb a-center" style="color: #000000;font-size: 0.75rem;">
						<div v-if="shopDetail.is_confirm == 1" style="border: 1px solid #000000;height: 1.42rem;line-height: 1.42rem;border-radius: 20px;padding: 0 1.05rem;cursor: pointer;font-weight: bold;" @click="closeCompany">暂时关闭</div>
						<div v-else style="border: 1px solid #000000;height: 1.42rem;line-height: 1.42rem;border-radius: 20px;padding: 0 1.05rem;cursor: pointer;font-weight: bold;" @click="openCompany">暂时开启</div>
						<div style="border: 1px solid #000000;height: 1.42rem;line-height: 1.42rem;border-radius: 0.71rem;padding: 0 1.05rem;margin-left: 1.22rem;cursor: pointer;font-weight: bold;" @click="delCompany">删除分公司</div>
					</div>
				</div>
			</content>
		</div>
		<div class="shop_decoration">
			<header style="margin-bottom: 2.58rem;">
				<div class="d-flex j-start a-center">
					<img src="../../assets/distributors/biaoqian@2x.png" style="width: 0.94rem; height: 1.13rem;margin-right: 0.28rem;">
					<span style="font-weight: 700; font-size: 0.94rem;">门店运营样式</span>
				</div>
			</header>
			<!-- 品牌装修 -->
			<div class="right">
				<div class="mobile">
					<div class="mobile-box position-relative" >
						<div class="position-relative">
							<img style="width: 272px;height: 9px;margin-left: 5px;position: absolute;top: 0;left: 0;right: 0;z-index: 999;" src="../../assets/distributors/zhaungtai@2x.png" />
							<div style="width: 281px;height: 138px;position: absolute;top: 0;left: 0;right: 0;background: linear-gradient(0deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.4) 100%);">
								<img style="width: 281px;height: 138px;" v-if="shophead.street_thumb" :src="shophead.street_thumb"/>
							</div>
							<div style="width: 281px;height: 138px;position: absolute;top: 0;left: 0;right: 0;background: linear-gradient(0deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.4) 100%);"></div>
							<div class="position-absolute d-flex a-center" style="height: 23px;left: 0;right: 0;top: 15px;">
								<img style="width: 22px;height: 22px;" 
								src="../../assets/brand_fixtures/jtz.png"/>
								<div style="width: 276px;height: 23px;margin-left: 3px;background: #F5F5F5;border-radius: 15px;display: flex;align-items: center;">
									<img style="width: 14px;height: 14px;margin-left: 8px;" src="../../assets/brand_fixtures/shoushuo.png" />
									<div style="color: #ABABAB;font-size: 13PX;margin-left: 8px;">请输入您喜欢的商品</div>
								</div>
								<img style="width: 22px;height: 22px;margin-left: 5px;"
								src="../../assets/brand_fixtures/xiaoxi.png" />
							</div>
							<div style="width: 100%;position: absolute;top: 45px;left: 0;right: 0;padding: 0 15px;box-sizing: border-box;">
								<div style="width: 100%;height: 100%;display: flex;justify-content: space-between;">
									<div style="height: 100;display: flex;align-items: center;justify-content: center;margin-right: 10px;">
										<img style="width: 46px;height: 46px;":src="shophead.logo_thumb"/>
									</div>
									<div class=" w-100 h-100 d-flex  a-center">
										<div class="d-flex j-sb flex-column w-100">
											<div class="d-flex j-sb a-center w-100">
												<div style="font-size: 12px;font-weight: 600;color: #FFFFFF;transform: scale(0.9);">{{shophead.rz_shopname}}</div>
												<img src="../../assets/distributors/guanzhu.png" style="width:46px;height: 15px;" alt="">
											</div>
											<div class="w-100 d-flex" style="justify-content: flex-start;">
												<div style="font-size: 10px;font-weight: 400;color: #FFFFFF;transform: scale(0.9);">{{'已有' + shophead.follow + '人关注'}}</div>
											</div>
											<div class="w-100 d-flex text-suojin" style="justify-content: flex-start;">
												<div style="font-size: 10px;font-weight: 400;color: #FFFFFF;transform: scale(0.9);">{{shopDetail.province + '省' + shopDetail.city + '市' + shopDetail.district + shopDetail.stores_address}}</div>
											</div>
										</div>
									</div>
									<div class="w-100 d-flex position-absolute" style="font-size: 12px;font-weight: 500;color: #FFFFFF;top: 65px;left: 0;right: 0;">
										<div class="w-100 d-flex j-sa a-center">
											<div class="d-flex flex-column j-center a-center">
												<div>精选推荐</div>
												<div style="width: 10px;height: 1px;background-color: white;"></div>
											</div>
											<div>全部商品</div>
											<div>活动商品</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div style=" box-sizing: border-box;overflow: scroll;background-color: #F4F4F4; height: 420px;width: 100%;position: relative;top: 138px;left: 0;right: 0;padding-left: 10px;padding-right: 10px;padding-top: 10px;">
							<div class="w-100 h-100" v-if="storebestgoods.length != 0">
								<div class="w-100" style="margin-bottom: 10px;" v-if="shophead.brand_thumb">
									<img :src="shophead.brand_thumb" style="width: 100%;height: 112px;" alt="">
								</div>
								<div class="w-100">
									<div class="w-100 d-flex j-center a-center" style="margin-bottom: 10px;">
										<img src="../../assets/distributors/rqtj@2x.png" style="width: 236px;height: 15px;" alt="">
									</div>
									<div class="w-100 d-flex j-sb flex-wrap" style="padding-bottom: 30px;">
										<div style="width: 128px;background-color: green;margin-bottom: 10px;background-color: #FFFFFF;" v-for="(item,index) in storebestgoods">
											<div style="width:100%;">
												<img :src="item.goods_thumb" style="width: 128px;height: 128px;" alt="">
											</div>
											<div class="w-100 d-flex flex-wrap j-sb" >
												<div class="text-suojin" style="font-size: 11px;font-weight: 500;color: #000000;transform: scale(0.9);">{{item.goods_name}}</div>
												<div style="font-size: 14px;font-weight: 800;color: #000000;padding-left: 8px;" >{{'¥' + item.shop_price}}</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="bottom-box d-flex ">
							<div style="width: 25%;height: 100%;" class="d-flex j-center a-center">
								<img style="border-radius: 50%;width: 35px;height: 35px;" :src="shophead.logo_thumb" />
							</div>
							<div class="d-flex j-center" style="width: 25%;height: 100%;flex-wrap: wrap;" >
								<img style="width: 19px;height: 19px;margin-top: 5px;" src="../../assets/distributors/fl@2x.png" />
								<div style="width: 100%;text-align: center;font-size: 10px;">商品分类</div>
							</div>
							<div class="d-flex j-center" style="width: 25%;height: 100%;flex-wrap: wrap;" >
								<img style="width: 19px;height: 19px;margin-top: 5px;" src="../../assets/distributors/huodong@2x.png" />
								<div style="width: 100%;text-align: center;font-size: 10px;">店铺活动</div>
							</div>
							<div class="d-flex j-center" style="width: 25%;height: 100%;flex-wrap: wrap;" >
								<img style="width: 19px;height: 19px;margin-top: 5px;" src="../../assets/distributors/kegu@2x.png" />
								<div style="width: 100%;text-align: center;font-size: 10px;">联系客服</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<ul class="tab d-flex j-sb a-center position-relative">
			<header class="d-flex j-start a-center" style="align-self: flex-start;padding: 0.94rem;position: absolute;">
				<img src="../../assets/distributors/biaoqian@2x.png" style="width: 0.94rem; height: 1.13rem;margin-right: 0.28rem;">
				<span style="font-weight: 700; font-size: 1rem;">订单数据</span>
			</header>
			<li class="h-100 d-flex flex-column j-end a-center">
				<span class="number">{{homeData.await_pay}}</span>
				<span class="name">待付款</span>
			</li>
			<li class="h-100 d-flex flex-column j-end a-center">
				<span class="number">{{homeData.await_ship}}</span>
				<span class="name">待发货</span>
			</li>
			<li class="h-100 d-flex flex-column j-end a-center">
				<span class="number">{{homeData.await_pickup}}</span>
				<span class="name">待取货</span>
			</li>
			<li class="h-100 d-flex flex-column j-end a-center">
				<span class="number">{{homeData.await_receiving}}</span>
				<span class="name">待收货</span>
			</li>
			<li class="h-100 d-flex flex-column j-end a-center">
				<span class="number">{{homeData.order_cancelled}}</span>
				<span class="name">已取消</span>
			</li>
			<li class="h-100 d-flex flex-column j-end a-center">
				<span class="number">{{homeData.finished}}</span>
				<span class="name">已完成</span>
			</li>
			<li class="h-100 d-flex flex-column j-end a-center">
				<span class="number">{{homeData.await_comment}}</span>
				<span class="name">待评价</span>
			</li>
			<li class="h-100 d-flex flex-column j-end a-center">
				<span class="number">{{homeData.return_number}}</span>
				<span class="name">退/换售后</span>
			</li>
		</ul>
		<div class="sales_data d-flex flex-column j-start a-start">
			<header class="w-100 d-flex j-sb a-center">
				<div class="d-flex j-start a-center">
					<img src="../../assets/distributors/biaoqian@2x.png" style="width: 0.94rem; height: 1.13rem;margin-right: 0.28rem;">
					<span style="font-weight: 700; font-size: 1rem;">销售数据</span>
				</div>
				<span style="font-size: 0.66rem; color: #666666;">{{nowdate}}</span>
			</header>
			<div class="total_volume d-flex j-start a-center" style="margin: 0.8rem 0; font-weight: 700;">
				<img src="../../assets/distributors/zongxiaojinge@2x.png" style="width: 1.88rem;height: 1.88rem;margin-right: 0.28rem;">
				<div class="h-100 d-flex flex-column j-sb a-start">
					<span style="font-size: 0.75rem;color: #666666;">总成交金额</span>
					<span style="font-size: 0.88rem;line-height: 0.88rem;">{{ '￥' + shopTotalmoney}}</span>
				</div>
			</div>
			<div class="table flex-1" ref="sales_table" style="width: 28.5rem;"></div>
		</div>
		<div class="census d-flex flex-column j-sb ac-center">
			<header class="w-100 d-flex j-sb a-center">
				<div class="d-flex j-center a-center">
					<img src="../../assets/distributors/biaoqian@2x.png" style="width: 0.94rem; height: 1.13rem;margin-right: 0.28rem;">
					<span style="font-size: 1rem;font-weight: 700;">数据统计</span>
				</div>
			</header>
			<div class="wrap flex-1 d-flex flex-wrap j-sb a-center" style="font-weight: 700;">
				<div class="d-flex j-center a-center" style="width: 50%;font-size: 0.75rem;">
					<img src="../../assets/distributors/jingrichengjiao@2x.png" style="width: 1.88rem;height: 1.88rem;margin-right: 0.2rem;">
					<div class="d-flex flex-column j-sb a-center" style="height: 3.1rem;">
						<span>今日成交量</span>
						<span style="font-size: 0.88rem;font-weight: 700;">{{today_data.sales_volume || 0}}</span>
						<div class="d-flex j-center a-center">
							<span :style="growth_rate.sales_volume== 0 ?'color:#FF9D10':checkUp(growth_rate.sales_volume)==-1?'color:#FF4810':'color:#1AC022'"
							 v-text="growth_rate.sales_volume == 0 ?'持平':growth_rate.sales_volume + '%'"></span>
							<img v-if="growth_rate.sales_volume!= 0"
							:src="checkUp(growth_rate.sales_volume)==-1?require('../../assets/Home/shangjiantou@2x.png'):require('../../assets/Home/xiajiantou@2x.png')"
							 style="width: 0.63rem;height: 0.63rem;">
						</div>
					</div>
				</div>
				<div class="d-flex j-center a-center" style="width: 50%;font-size: 0.75rem;">
					<img src="../../assets/distributors/jingridingdan@2x.png" style="width: 1.88rem;height: 1.88rem;margin-right: 0.2rem;">
					<div class="d-flex flex-column j-sb a-center" style="height: 3.1rem;">
						<span>今日订单量</span>
						<span style="font-size: 0.88rem;font-weight: 700;">{{today_data.order_num || 0}}</span>
						<div class="d-flex j-center a-center">
							<span :style="growth_rate.order_num== 0 ?'color:#FF9D10':checkUp(growth_rate.order_num)==-1?'color:#FF4810':'color:#1AC022'"
							 v-text="growth_rate.order_num == 0 ?'持平':growth_rate.order_num + '%'"></span>
							<img v-if="growth_rate.order_num!= 0"
							:src="checkUp(growth_rate.order_num)==-1?require('../../assets/Home/shangjiantou@2x.png'):require('../../assets/Home/xiajiantou@2x.png')"
							 style="width: 0.63rem;height: 0.63rem;">
						</div>
					</div>
				</div>
				<div class="d-flex j-center a-center" style="width: 50%;font-size: 0.75rem;">
					<img src="../../assets/distributors/jinriliulan@2x.png" style="width: 1.88rem;height: 1.88rem;margin-right: 0.2rem;">
					<div class="d-flex flex-column j-sb a-center" style="height: 3.1rem;">
						<span>今日浏览量</span>
						<span style="font-size: 0.88rem;font-weight: 700;">{{today_data.visit_num || 0}}</span>
						<div class="d-flex j-center a-center">
							<span :style="growth_rate.visit_num== 0 ?'color:#FF9D10':checkUp(growth_rate.visit_num)==-1?'color:#FF4810':'color:#1AC022'"
							 v-text="growth_rate.visit_num == 0 ?'持平':growth_rate.visit_num + '%'"></span>
							<img v-if="growth_rate.visit_num!= 0"
							:src="checkUp(growth_rate.visit_num)==-1?require('../../assets/Home/shangjiantou@2x.png'):require('../../assets/Home/xiajiantou@2x.png')"
							 style="width: 0.63rem;height: 0.63rem;">
						</div>
					</div>
				</div>
				<div class="d-flex j-center a-center" style="width: 50%;font-size: 0.75rem;">
					<img src="../../assets/distributors/jinrikedan@2x.png" style="width: 1.88rem;height: 1.88rem;">
					<div class="d-flex flex-column j-sb a-center" style="height: 3.1rem;">
						<span>今日客单价</span>
						<span style="font-size: 0.88rem;">{{today_data.ke_unit_price || 0}}</span>
						<div class="d-flex j-center a-center">
							<span :style="growth_rate.ke_unit_price== 0 ?'color:#FF9D10':checkUp(growth_rate.ke_unit_price)==-1?'color:#FF4810':'color:#1AC022'"
							 v-text="growth_rate.ke_unit_price == 0 ?'持平':growth_rate.ke_unit_price + '%'"></span>
							<img v-if="growth_rate.ke_unit_price!= 0"
							:src="checkUp(growth_rate.ke_unit_price)==-1?require('../../assets/Home/shangjiantou@2x.png'):require('../../assets/Home/xiajiantou@2x.png')"
							 style="width: 0.63rem;height: 0.63rem;">
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="distribute_item d-flex flex-column j-start a-center">
			<header class="w-100 d-flex j-sb a-center" style="margin-bottom: 1.6rem;">
				<div class="d-flex j-center a-center">
					<img src="../../assets/distributors/biaoqian@2x.png" style="width: 0.94rem; height: 1.13rem;margin-right: 0.28rem;">
					<span style="font-size: 1rem;font-weight: 700;">门店商品概况</span>
				</div>
				<div class="d-flex j-center a-center">
					<router-link style="color: #BBBBBB;font-size: 0.75rem;" :to="{name:'shopgoods_mesage',params:{id:agent_id}}" v-slot="{ href, route, navigate, isActive, isExactActive }"
					 custom>
						<a :href="href" class="d-flex j-center a-center" style="text-decoration: none;">
							<span>查看更多</span>
							<img src="@/assets/Home/kanquanbu@2x.png" style="width: 0.58rem;height: 0.58rem;">
						</a>
					</router-link>
				</div>
			</header>
			<div class="box flex-1 w-100">
				<div class="table h-100 w-100 d-flex flex-column j-start a-sb" style="text-align: center;">
					<div class="d-flex j-sb a-center" style="height: 10%;font-weight: 700;font-size: 0.75rem;">
						<span style="flex: .3;">排名</span>
						<span style="flex: 1;">商品信息</span>
						<div class="flex-1 d-flex j-center a-center">
							<span style="line-height: 1rem;">销量<span style="font-size: 0.56rem;color: #666666;">(件)</span></span>
						</div>
						<div class="d-flex j-center a-center" style="flex: .5;">
							<span style="line-height: 1rem">成交金额<span style="font-size: 0.75rem;color: #666666;">(元)</span></span>
						</div>
					</div>
					<div class="row d-flex j-center a-center h-100"  v-if="distributorgoods.length == 0">暂无数据</div>
					<div class="row d-flex j-sa a-center" style="font-size: 0.75rem;height: 33.3%;color: #666666;" v-for="(item,index) in distributorgoods"
					 :key="index">
						<div style="flex: .3;">
							<img v-if="item.rank < 4" :src="item.rank==1?require('@/assets/Home/diyi@2x.png'):item.rank==2?require('@/assets/Home/dier@2x.png'):require('@/assets/Home/disan@2x.png')"
							 style="width: 1.41rem;height: 1.41rem; vertical-align: middle;">
							<span v-else>{{item.rank}}</span>
						</div>
						<div style="flex: 1;">
							<div class="wrap d-flex j-center a-center" style="max-width: 16rem;margin: 0 auto;">
								<img :src="item.goods_thumb" style="width: 1.88rem;height: 1.88rem;margin-right: 0.58rem;">
								<span style="text-align: left; overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">{{item.goods_name}}</span>
							</div>
						</div>
						<span class="flex-1">{{item.sale_number}}</span>
						<span style="flex: .5;">{{item.count_price}}</span>
					</div>
				</div>
			</div>
		</div>
		<div class="sales_GDP">
			<header>
				<div class="d-flex j-start a-center">
					<img src="../../assets/distributors/biaoqian@2x.png" style="width: 0.94rem; height: 1.13rem;margin-right: 0.28rem;">
					<span style="font-weight: 700; font-size: 0.94rem;">销售占比</span>
				</div>
			</header>
			<div class="table" ref="GDP" style="width: 8.26rem;height: 8.26rem;margin: 0 auto;"></div>
			
			<div v-if="shopDetail.up_agent_name">
				<div class="d-flex j-sb a-center" style="font-size: 0.75rem;margin: 1rem 0;">
					<div class="d-flex j-center a-center">
						<div style="width: 0.28rem;height: 0.28rem;background:#FFB400;margin-right: 0.42rem;"></div>
						<span>市分公司:</span>
					</div>
					<span style="flex: 1;padding-left: 1.1rem;">{{shopDetail.up_agent_name}}</span>
				</div>
				<div class="d-flex j-sb a-center" style="font-size: 0.75rem;">
					<div class="d-flex j-center a-center">
						<div style="width: 0.28rem;height: 0.28rem;background:#1E69FF;margin-right: 0.42rem;"></div>
						<span>加盟门店:</span>
					</div>
					<span style="flex: 1;padding-left: 1.1rem;">{{shopDetail.agent_name}}</span>
				</div>
			</div>
			<div v-else>
				<div class="d-flex j-sb a-center" style="font-size: 0.75rem;margin: 1rem 0;">
					<div class="d-flex j-center a-center">
						<div style="width: 0.28rem;height: 0.28rem;background:#FFB400;margin-right: 0.42rem;"></div>
						<span>品牌直营店:</span>
					</div>
					<span style="flex: 1;padding-left: 1.1rem;">所有直营店</span>
				</div>
				<div class="d-flex j-sb a-center" style="font-size: 0.75rem;">
					<div class="d-flex j-center a-center">
						<div style="width: 0.28rem;height: 0.28rem;background:#1E69FF;margin-right: 0.42rem;"></div>
						<span>当前直营店:</span>
					</div>
					<span style="flex: 1;padding-left: 1.1rem;">{{shopDetail.agent_name}}</span>
				</div>
			</div>
		</div>
		<div class="purchase_data d-flex flex-column j-start a-center">
			<header class="w-100 d-flex j-sb a-center" style="margin-bottom: 1.6rem;">
				<div class="d-flex j-center a-center">
					<img src="../../assets/distributors/biaoqian@2x.png" style="width: 0.94rem; height: 1.13rem;margin-right: 0.28rem;">
					<span style="font-size: 1rem;font-weight: 700;">采购数据</span>
				</div>
				<div class="d-flex j-center a-center">
					<router-link style="color: #BBBBBB;font-size: 0.75rem;" :to="{name:'shopbuy_message',params:{id:agent_id}}" v-slot="{ href, route, navigate, isActive, isExactActive }"
					 custom>
						<a :href="href" class="d-flex j-center a-center" style="text-decoration: none;">
							<span>查看更多</span>
							<img src="@/assets/Home/kanquanbu@2x.png" style="width: 0.58rem;height: 0.58rem;">
						</a>
					</router-link>
				</div>
			</header>
			<div class="box flex-1 w-100">
				<div class="table h-100 w-100 d-flex flex-column j-start a-sb" style="text-align: center;">
					<div class="d-flex j-sb a-center" style="height: 10%;font-weight: 700;font-size: 0.75rem;">
						<span style="flex: .3;">排名</span>
						<span style="flex: 1;">商品信息</span>
						<div class="flex-1 d-flex j-center a-center">
							<span style="line-height: 1rem;">采购数量<span style="font-size: 0.56rem;color: #666666;">(件)</span></span>
						</div>
						<div class="d-flex j-center a-center" style="flex: .5;">
							<span style="line-height: 1rem">采购金额<span style="font-size: 0.75rem;color: #666666;">(元)</span></span>
						</div>
					</div>
					<div class="row d-flex j-center a-center h-100"  v-if="shopBuymath.length == 0">暂无数据</div>
					<div class="row d-flex j-sa a-center" style="font-size: 0.75rem;height: 33.3%;color: #666666;" v-for="(item,index) in shopBuymath"
					 :key="item.rank">
						<div style="flex: .3;">
							<img v-if="item.rank < 4" :src="item.rank==1?require('@/assets/Home/diyi@2x.png'):item.rank==2?require('@/assets/Home/dier@2x.png'):require('@/assets/Home/disan@2x.png')"
							 style="width: 1.41rem;height: 1.41rem; vertical-align: middle;">
							<span v-else>{{item.rank}}</span>
						</div>
						<div style="flex: 1;">
							<div class="wrap d-flex j-center a-center" style="max-width: 16rem;margin: 0 auto;">
								<img :src="item.goods_thumb" style="width: 1.88rem;height: 1.88rem;margin-right: 0.58rem;">
								<span style="text-align: left; overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">{{item.goods_name}}</span>
							</div>
						</div>
						<span class="flex-1">{{item.purchase_volume}}</span>
						<span style="flex: .5;">{{item.purchase_amount}}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import * as echarts from 'echarts';
	export default {
		data() {
			return {
				period: ['近30天', '近3个月', '近6个月'],
				curIndex: 0,
				homeData: '',
				orderByNum: true,
				orderByMoney: false,
				num_isDesc: true,
				money_isDesc: true,
				option2: {
					tooltip: {
						trigger: 'item'
					},
					series: [{
						name: '访问来源',
						type: 'pie',
						radius: ['50%', '90%'],
						avoidLabelOverlap: false,
						label: {
							show: false,
							position: 'center',
							fontSize: '0.75rem',
							fontWeight: 'bold',
							formatter: `{a|{d}%\n}{b|总占比(%)}`,
							rich: {
								a: {
									color: ['#1E69FF', '#FFB400'],
									lineHeight: 10
								},
								b: {
									color: '#000000',
									lineHeight: 10
								},
							}
						},
						color: ['#1E69FF', '#FFB400'],
						emphasis: {
							label: {
								show: true
							}
						},
						labelLine: {
							show: false
						},
						data: [{
								value: 10048,
								name: '格力广东省分公司'
							},
							{
								value: 735,
								name: '珠海格力电器股份有限公司'
							}
						]
					}]
				},
				option3: {
					grid: {
						left: 25,
						righ: 20,
						top: 0,
						bottom: 20
					},
					tooltip: {
						trigger: 'item'
					},
					xAxis: {
						type: 'category',
						boundaryGap: false,
						splitLine: {
							show: false
						},
						axisPointer: {
							show: true,
							lineStyle: {
								color: ['#1E69FF']
							}
						},
						axisLabel: {
							fontSize: '0.65rem'
						}
					},
					yAxis: {
						type: 'value',
						show: false,
						// boundaryGap: [0, '%'],
						axisLabel: {
							show: false
						},
					},
					series: [{
						type: 'line',
						smooth: 0.5,
						itemStyle: {
							width: '10',
							color: '#1E69FF',
							borderColor: '#FFFFFF',
							borderWidth: '4',
						},
						symbolSize: '8',
						lineStyle: {
							color: '#1E69FF',
							width: 3
						},
						areaStyle: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: 'rgb(214, 228, 255)'
							}, {
								offset: 1,
								color: 'rgb(255, 255, 255)'
							}])
						},
						emphasis: {
							itemStyle: {
								color: '#1E69FF',
								borderColor: '#FFFFFF'
							}
						},
						// data: [0,0,0,0,0,0,0]					
					}]
				},
				rank: [{
					rank: 1,
					item: {
						name: 'Gree/格力晶弘 225升电冰箱三开门家用小型宿舍用迷你租房用节能',
						icon: require('@/assets/Home/danpinxiaoliang@2x.png')
					},
					sales_volume: 25369,
					sales_amount: 1236943.22
				}, {
					rank: 2,
					item: {
						name: 'Gree/格力晶弘 225升电冰箱三开门家用小型宿舍用迷你租房用节能',
						icon: require('@/assets/Home/danpinxiaoliang@2x.png')
					},
					sales_volume: 20369,
					sales_amount: 1236943.22
				}, {
					rank: 3,
					item: {
						name: 'Gree/格力晶弘 225升电冰箱三开门家用小型宿舍用迷你租房用节能',
						icon: require('@/assets/Home/danpinxiaoliang@2x.png')
					},
					sales_volume: 11469,
					sales_amount: 1236943.22
				}],
				nowdate : '',
				agent_id : '',
				growth_rate : {},
				today_data : {},
				shopDetail : [],
				shopTotalmoney : 0,
				distributorgoods: [],
				shopBuymath : [],
				shop_user_id : '',
				shophead : {},
				storebestgoods :[]
			}
		},
		watch: {
			orderByNum(newValue, oldValue) {
				if (newValue == false) {
					this.num_isDesc = false
				}
			},
			orderByMoney(newValue, oldValue) {
				if (newValue == false) {
					this.money_isDesc = false
				}
			}
		},
		methods:{
			checkUp(data) {
				let status =  (data+'').indexOf('-')
				return status
			},
			nowDate() {
				let date = new Date();
				let month = date.getMonth() + 1
				this.nowdate = date.getFullYear() + '-' + month + '-' +date.getDate()
			},
			getshopDetails(){
				let param = {
					act : 'agent_info',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					agent_id : this.agent_id,
				}
				this.$api.company_list(param).then((res) => {
					if(res.code == 0){
						this.shopDetail = res.data
						this.getShopmessage()
						this.getStorebest()
						// this.getDistributorshop()
					}else {
						this.$message.error('发生错误，请重试');
					}
				}).catch((err) => {
					this.$message.error(err);
				})
			},
			getHomeData() {
				let param = {
					act: 'order_data',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					agent_id : this.agent_id
				}
				this.$api.homeData(param).then((res) => {
					this.homeData = res.data
					localStorage.setItem('homeData', JSON.stringify(res.data))
				})
			},
			// 获取门店头部样式
			getShopmessage(){
				let param = {
					user_id: localStorage.getItem('user_id'),
					seller_id : this.shopDetail.login_user_id
				}
				this.$api.getShopmessage(param).then((res) => {
					if(res.code == 0){
						this.shophead = res.data
					}else {
						
					}
				})
			},
			// 获取推荐商品
			getStorebest(){
				let param = {
					seller_id : this.shopDetail.login_user_id,
					page : 1,
					seze : 8
				}
				this.$api.getStorebestgoods(param).then((res) => {
					if(res.code == 0){
						console.log(res);
						this.storebestgoods = res.data
					}else {
						
					}
				})
			},
			initShopcharts(){
				let p1 = this.$api.company_list({
					act:'week_sales_data',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					agent_id : this.agent_id,
				})
				let p2 = this.$api.company_list({
					act:'sale_proportion',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					agent_id : this.agent_id
				})
				Promise.all([p1,p2]).then((res) => {
					let optionsData3 = res[0]
					if(optionsData3.code == 0){
						this.option3.xAxis.data = optionsData3.data.week_sales_data.dates_data
						this.option3.series[0].data = optionsData3.data.week_sales_data.sales_data.map(Number)
						this.shopTotalmoney = parseFloat(optionsData3.data.count_sales_amount).toFixed(2)
					}else {
						this.$message.warning(optionsData3.msg)
					}
					let optionData2 = res[1]
					let data2 = [{
							value: 0,
							name: ''
						},{
							value: 0,
							name: ''
						}
					]
					if(optionData2.code == 0){
						data2[0].value = optionData2.data
						data2[0].name = this.shopDetail.agent_name
						data2[1].value = 100 - data2[0].value
						data2[1].name = this.shopDetail.up_agent_name ? this.shopDetail.up_agent_name : '所有直营店'
						this.option2.series[0].data = data2
					}else {
						data2[0].value = optionData2.data
						data2[0].name = this.shopDetail.agent_name
						data2[1].value = 100
						data2[1].name = this.shopDetail.up_agent_name ? this.shopDetail.up_agent_name : '所有直营店'
						this.option2.series[0].data = data2
					}
					let chartDom3 = this.$refs.sales_table
					let myChart3 = echarts.init(chartDom3)
					this.option3 && myChart3.setOption(this.option3)
					let chartDom2 = this.$refs.GDP
					let myChart2 = echarts.init(chartDom2)
					this.option2 && myChart2.setOption(this.option2)
					setTimeout(function() {
						window.onresize = function() {
							myChart2.resize();
							myChart3.resize();
						}
					}, 200)
				})
			},
			closeCompany(){
				if(this.shopDetail.is_confirm == 0){
					this.$message.warning('该分销商已经处于关闭状态')
					return
				}
				let param = {
					act : 'operation_agent_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					agent_ids : this.shopDetail.agent_id,
					ctrl : 'close'
				}
				this.$api.company_list(param).then((res) => {
					if(res.code == 0){
						this.$message.success(res.msg);
						this.shopDetail.is_confirm = 0
					}else{
						this.$message.error(res.msg);
					}
				}).catch((err) => {
					this.$message.error(err);
				})
			},
			openCompany(){
				let param = {
					act : 'operation_agent_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					agent_ids : this.shopDetail.agent_id,
					ctrl : 'open'
				}
				this.$api.company_list(param).then((res) => {
					if(res.code == 0){
						this.$message.success(res.msg);
						this.shopDetail.is_confirm = 1
					}else{
						this.$message.error(res.msg);
					}
				}).catch((err) => {
					this.$message.error(err);
				})
			},
			delCompany(){
				let param = {
					act : 'operation_agent_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					agent_ids : this.shopDetail.agent_id,
					ctrl : 'del'
				}
				this.$api.company_list(param).then((res) => {
					if(res.code == 0){
						this.$message.success(res.msg);
					}else{
						this.$message.error(res.msg);
					}
				}).catch((err) => {
					this.$message.error(err);
				})
			},
			dataStatisticsRight(){
				let param = {
					act : 'data_statistics_right',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					agent_id : this.agent_id,
				}
				this.$api.company_list(param).then((res) => {
					if(res.code == 0){
						this.growth_rate = res.data.growth_rate
						this.today_data = res.data.today_data
					}else {
						
					}
				}).catch((err) => {
					this.$message.error(err);
				})
			},
			getDistributorgoods(){
				let param = {
					act: 'store_goods_survey',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					agent_id : this.agent_id,
					sort_field : 'sale_number',
					sort : 'desc',
					type : -1,
					page : 1,
					size : 3
				}
				this.$api.company_list(param).then((res) => {
					if(res.code == 0){
						this.distributorgoods = res.data
						this.distributorgoods.forEach((item,index) => {
							item.rank = index +1
						})
					}
				})
			},
			getShopbuymath(){
				let param = {
					act: 'store_purchase_data',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					agent_id : this.agent_id,
					sort_field : 'purchase_volume',
					sort : 'desc',
					page : 1,
					size : 3
				}
				this.$api.company_list(param).then((res) => {
					if(res.code == 0){
						this.shopBuymath = res.data
						this.shopBuymath.forEach((item,index) => {
							item.rank = index +1
						})
					}
				})
			},
			changeSort(type) {
				if (type == 'num') {
					this.orderByNum = true
					this.orderByMoney = false
					this.num_isDesc = !this.num_isDesc
				} else {
					this.orderByNum = false
					this.orderByMoney = true
					this.money_isDesc = !this.money_isDesc
				}
			},
		},
		mounted() {
			this.agent_id = this.$route.params.id
			this.nowDate()
			this.getshopDetails()
			this.getHomeData()
			this.initShopcharts()
			this.dataStatisticsRight()
			this.getDistributorgoods()
			this.getShopbuymath()
			this.homeData = JSON.parse(localStorage.getItem('homeData'))
		},

	}
</script>

<style lang="scss" scoped>
	@mixin common {
		background: #FFFFFF;
		border-radius: 6px;
		padding: 1.1rem 0.94rem;
		box-sizing: border-box;
	}

	@mixin table {
		table {
			text-align: center;

			th {
				font-size: 0.77rem;
			}

			tr {

				td {
					margin: 0 2rem;
				}
			}
		}
	}

	.shop_detail {
		max-width: 73.24rem;
		margin: 0 auto;
		width: 100%;
		display: grid;
		grid-template-rows: 7.32rem 5.38rem 10.77rem 16.15rem 15.22rem;
		grid-template-columns: 23rem 31.92rem 16.43rem;
		gap: 0.94rem;

		.base_info {
			grid-column: 1;
			grid-row: 1/3;
			@include common;

			.icon {
				background: url(../../assets/distributors/mendiantu@2x.png);
				background-size: 100% 100%;
				background-repeat: no-repeat;
			}
		}

		.shop_decoration {
			grid-column: 1;
			grid-row: 3/8;
			@include common;
			.preview {
				width: 18.59rem;
				height: 37.09rem;
				margin: 0 auto;
			}

		}
		.shop-preview{
			width: 100%;
			height: 100%;
			background: red;
			border-radius: 1rem;
			border: 6px solid #0C275E;
		}
		.tab {
			grid-row: 1/2;
			grid-column: 2/4;
			background: #FFFFFF;
			border-radius: 6px;

			li {
				list-style: none;
				flex: 1;
				padding: 1.17rem 0;
				box-sizing: border-box;
				cursor: pointer;

				.logo {
					width: 1.6rem;
					height: 1.6rem;
				}

				.number {
					font-size: 1.13rem;
					font-weight: 700;
				}

				.name {
					font-size: 0.75rem;
					color: #666666;
					font-weight: bold;
				}

				&:hover {
					background: #E7EFFF;
				}
			}
		}
		.right{
			flex: 1;
			display: flex;
			.mobile{
				width: 297px;
				height: 592px;
				border-radius: 14px;
				box-sizing: border-box;
				border: 8px solid #0C275E;
				.mobile-box{
					width: 100%;
					height: 100%;
					background: #F6F6F6;
					border-radius: 10px;
					position: relative;
					.mobile-list{
						width: 325px;
						height: 80px;
						background: #FFFFFF;
						border-radius: 6px;
						margin-left: 5px;
						padding: 11px;
						box-sizing: border-box;
						margin-top: 10px;
					}
					.bottom-box{
						width: 279px;
						height: 46px;
						background: #FFFFFF;
						box-shadow: 0px -10px 20px 0px rgba(209, 209, 209, 0.48);
						border-radius: 0px 0px 8px 8px;
						position: absolute;
						bottom: 0;
						left: 0;
						right: 0;
					}
					.left-tab{
						width: 100px;
						height: 468px;
						background: #f5f5f5;
						overflow-y: scroll;
					}
					.inner-container::-webkit-scrollbar {
					  display: none;
					}
					.right-tab{
						width: 235px;
						height: 468px;
						background: #ffffff;
						overflow-y: scroll;
					}
					.right-tab-scr::-webkit-scrollbar {
					  display: none;
					}
					
				}
			}
			.brand-home{
				margin-left: 80px;
				.shop-item{
					width: 305px;
					height: 70px;
					background: #FFFFFF;
					margin-left: 5px;
					padding: 8px;
					box-sizing: border-box;
					margin-top: 10px;
					box-shadow: 0px 6px 16px 0px rgba(30, 105, 255, 0.17);
					border-radius: 4px;
					font-size: 9px;
					margin-left: 23px;
				}
			}
		}
		.sales_data {
			@include common;
			grid-row: 2/4;
			grid-column: 2/3;
		}

		.census {
			@include common;
			grid-row: 2/4;
			grid-column: 3/4;
		}

		.distribute_item {
			@include common;
			@include table;
			grid-row: 4/5;
			grid-column: 2/3;
		}

		.sales_GDP {
			@include common;
			grid-row: 4/5;
			grid-column: 3/4;
		}

		.purchase_data {
			@include common;
			@include table;
			grid-row: 5/8;
			grid-column: 2/4;
		}
		.text-suojin{
			text-overflow: ellipsis;
			overflow: hidden;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
		}
		::-webkit-scrollbar {
		  display: none; /* Chrome Safari */
		}
	}
</style>